module.exports = __webpack_public_path__ + "img/31.93d76ea2.png";